module.exports = __webpack_public_path__ + "media/images/logo-admin-15b5fa7c.svg";